export default __webpack_public_path__ + "static/media/Ilus-Compara.a26d51db.svg";